<template>
  <div class="regional_questionaire__question">
    <div class="text-sm font-bold">{{ question.question }}</div>

    <div v-if="total > 0" class="mt-2 flex items-center justify-between">
      <ul class="rounded p-2 text-sm">
        <li
          v-for="(answer, index) in results"
          :key="index"
          class="flex items-center"
        >
          <div
            class="mr-2 h-2 w-2 rounded-full"
            :style="{ 'background-color': answer.color }"
          ></div>
          <div class="">{{ answer.label }}: {{ answer.count }}</div>
        </li>
      </ul>
      <Pie :results="results" :total="total" class="h-24 w-24"></Pie>
    </div>
    <div
      v-else
      class="mt-2 flex min-h-6 items-center justify-center rounded bg-black-900 text-sm italic"
    >
      Noch keine Daten vorhanden
    </div>
  </div>
</template>

<script>
import Pie from '~components/utils/Pie.vue'

const answers = {
  a1: 'Ist mir sehr wichtig',
  a2: 'Ist mir nicht wichtig',
  a3: 'Habe keine Meinung dazu',
}

export default {
  components: {
    Pie,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    total() {
      return this.question.a1 + this.question.a2 + this.question.a3
    },
    results() {
      return [
        {
          label: answers.a1,
          count: this.question.a1,
          color: '#32AC5C',
        },
        {
          label: answers.a2,
          count: this.question.a2,
          color: '#E30613',
        },
        {
          label: answers.a3,
          count: this.question.a3,
          color: '#0095db',
        },
      ]
    },
  },
}
</script>

<style>
@import '~components/content/widgets/listings/RegionalQuestionaireQuestion.css';
</style>
